import React from 'react';
import { Card, Grid, Typography, CardContent, TextField, CardActions, Button, IconButton,InputAdornment, Icon, Slide,
		 List, ListItem, Avatar, ListItemText, LinearProgress, CircularProgress  } from '@material-ui/core';
import isEmail from 'validator/lib/isEmail';
import isEmpty from 'validator/lib/isEmpty';
import { withSnackbar } from 'notistack';
import { Helmet } from "react-helmet";

//CSS
import '../auth.css';

//images
// import Logo from '../../../images/logo_small.png';


//Services
import AuthAPI from '../../../../services/api/Auth';
import Session from '../../../../services/auth/Session';

class Login extends React.Component {

	state = {
		email: Session.GetUsuarioLembrete() !== undefined ? Session.GetUsuarioLembrete() : '',
		senha:'',

		mostraSenha:false,
		isEmail:false,
		isSenha:false,

		clientes:[],
		choose:false,

		authload:false,
		clientload: true,
	}

    handleSubmit = (ev) => {
		ev.preventDefault();
		const { email, senha } = this.state;
		if(isEmpty(email) && isEmpty(senha)){
			this.setState({
				isEmail:true,
				isSenha:true,
			})
			this.props.enqueueSnackbar('Preencha os campos de email e senha!');
			return;
		}
		if(isEmpty(email) || !isEmail(email)){
			this.setState({
				isEmail:true,
			})
			this.props.enqueueSnackbar('Digite um email válido!');
			return;
		}

		if(isEmpty(senha)){
			this.setState({
				isSenha:true,
			})
			this.props.enqueueSnackbar('Digite uma senha válida!');
			return;
		}
		this.setState({
			authload:true,
			aviso:null,
			snackStatus:false,
			isEmail:false,
			isSenha:false,
		})
		let forms = {
			email: email,
			senha: senha,
		}
        AuthAPI.entrar(forms)
				.then(res => {
					res.json().then(res => {
						if(res.msg){
							this.setState({authload:false}, () =>this.props.enqueueSnackbar(res.msg));
							return;
						}
						Session.LoginSucesso(res)
						this.props.history.push('/painel/dashboard');


					})
				}).catch(() => this.props.enqueueSnackbar('Não foi possivel efetuar o login tente novamente mais tarde.'))
	}

    render() {
		const { email, mostraSenha, isEmail, isSenha, choose, clientes, authload, clientload } = this.state;
        return (
            <div className="container__auth" >
				<Helmet>
					<title>Entrar</title>
				</Helmet>
				<div className="auth_body" >
					<div className="content" >
						<Card>
							{authload && <LinearProgress />}
							<div className="logo" >
								{/* <img alt="Logo" src={Logo} /> */}
							</div>
							{!choose && <form onSubmit={this.handleSubmit} >
									<CardContent>
										<Typography style={{textAlign:'center'}} color="textSecondary" variant="h6" gutterBottom>
											Entrar
										</Typography>
										<Typography color="textSecondary" variant="subtitle1" gutterBottom>
											Digite os dados abaixo para acessar o painel
										</Typography>
										<Grid container spacing={8} >
											<Grid item xs={12} >
												<TextField
													label="Email"
													value={email}
													autoFocus={email === ''}
													error={isEmail}
													fullWidth
													onChange={t => this.setState({ email: t.target.value })}
													margin="normal"
													variant="outlined"
													/>
											</Grid>
											<Grid item xs={7} >
												<TextField
													label="Senha"
													fullWidth
													type={ mostraSenha ? "text" : "password" }
													onChange={t => this.setState({ senha: t.target.value })}
													margin="normal"
													error={isSenha}
													autoFocus={email !== ''}
													variant="outlined"
													InputProps={{
														endAdornment: (
														<InputAdornment position="end">
															<IconButton
															aria-label="Toggle password visibility"
															onClick={() => this.setState({mostraSenha: !mostraSenha})}
															>
															{mostraSenha ? <Icon>visibility_off</Icon>: <Icon>visibility</Icon>}
															</IconButton>
														</InputAdornment>
														),
													}}
													/>
											</Grid>
										</Grid>
									</CardContent>
									<CardActions className="actions_form" >
										<Button variant="contained" type="submit" disabled={authload} color="primary" >Entrar</Button>
									</CardActions>
								</form>}
							<Slide direction="left" in={choose} mountOnEnter unmountOnExit>
								<CardContent style={{textAlign:'center'}} >
									<Typography color="textSecondary" variant="h6" gutterBottom>
										Escolha um cliente
									</Typography>
									{clientload ? <CircularProgress style={{margin:'30px 0px 30px 0px'}} /> : <List className="list_choose" >
										{clientes.map( c => {
											return <ListItem button key={c.id} onClick={() => this.chooseCliente(c)} >
												<Avatar>
													<Icon>work_outline</Icon>
												</Avatar>
												<ListItemText primary={c.nome} />
											</ListItem>
										})}
									</List>}
								</CardContent>
							</Slide>
						</Card>
					</div>
				</div>
			</div>
        );
    }
}

export default withSnackbar(Login)



// WEBPACK FOOTER //
// ./src/painel/pages/auth/entrar/index.js